import { CATALOG_ITEM_SCHEDULE_INTERVAL_TIME_STEP_IN_MS } from '@common/const/catalog/item';
import { DEAL_LENGTH_MIN_IN_MS } from '@common/const/deal';
import { DATE_PICKER_VALUE_DATE_FORMAT_DEFAULT } from '@cp/ds/src/components/form/components/field/dateTimePicker/const';

export const DATE_VALUE_FORMAT = DATE_PICKER_VALUE_DATE_FORMAT_DEFAULT;

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const MIN_RANGE_BETWEEN_START_AND_NOW_IN_MS = 60 * 60 * 1000;

 
export const TIME_FIELD_LIST_STEP_IN_MS = CATALOG_ITEM_SCHEDULE_INTERVAL_TIME_STEP_IN_MS;

 
export const MIN_RANGE_BETWEEN_START_AND_END_IN_MS = DEAL_LENGTH_MIN_IN_MS;
